export const KEY_LANGUAGE_SESSION_STORAGE="LANGUAGE"